import { APImageProps } from './types';

export const APImage = ({
  img,
  className = '',
  alt = '',
  width,
  height,
  loadingStrategy = 'lazy',
  onError,
}: APImageProps) => {
  return (
    <img
      src={img}
      alt={alt}
      width={width}
      height={height}
      loading={loadingStrategy}
      className={`inline-block mr-1 ${className}`}
      onError={onError}
    />
  );
};
